/* eslint-disable no-restricted-imports */
/* eslint-disable complexity */
/* eslint-disable functional/no-loop-statement */

import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { DpScrollContainer } from '@/components/blocks/ScrollContainer';

export const DpScrollFrame: FC<{
	children: JSX.Element[];
}> = ({ children, ...props }) => {
	const scrollContainerRef = useRef<HTMLDivElement>(null);

	const [startPosition, setStartPosition] = useState(0);
	const [scrollPosition, setScrollPosition] = useState(0);
	const [hasMoved, setHasMoved] = useState(false);

	const positions = useMemo(() => {
		const positionsTemp = [];
		for (let i = 0; i < children.length; i++) {
			positionsTemp.push(i * 310);
		}
		return positionsTemp;
	}, [children.length]);

	useEffect(() => {
		const scrollContainer = scrollContainerRef.current;

		const handleScroll = () => {
			if (!scrollContainer) return;
		};

		scrollContainer?.addEventListener('scroll', handleScroll);

		return () => {
			scrollContainer?.removeEventListener('scroll', handleScroll);
		};
	}, [positions, children.length]);

	const [isDragging, setIsDragging] = useState(false);

	// Umbral mínimo de movimiento para considerar que es un drag
	const DRAG_THRESHOLD = 5;

	const handleMouseDown = (e: MouseEvent) => {
		setIsDragging(true);
		setHasMoved(false);
		setStartPosition(e.clientX);
		setScrollPosition(scrollContainerRef.current?.scrollLeft || 0);
	};

	const handleMouseMove = (e: MouseEvent) => {
		if (isDragging && scrollContainerRef.current) {
			const distance = e.clientX - startPosition;

			// Marcar que hubo movimiento si supera el umbral
			if (Math.abs(distance) > DRAG_THRESHOLD) {
				setHasMoved(true);
			}

			scrollContainerRef.current.scrollLeft = scrollPosition - distance;
		}
	};

	const handleMouseUp = () => {
		setIsDragging(false);
		// Reset hasMoved después de un breve delay para permitir que se capture el evento click
		setTimeout(() => setHasMoved(false), 100);
	};

	const handleClick = (e: MouseEvent) => {
		// Prevenir clicks si hubo movimiento significativo
		if (hasMoved) {
			e.preventDefault();
			e.stopPropagation();
		}
	};

	useEffect(() => {
		const container = scrollContainerRef.current;
		if (container) {
			container.addEventListener('mousedown', handleMouseDown);
			container.addEventListener('mousemove', handleMouseMove);
			container.addEventListener('mouseup', handleMouseUp);
			container.addEventListener('mouseleave', handleMouseUp);
			container.addEventListener('click', handleClick, true); // capture phase
		}

		return () => {
			if (container) {
				container.removeEventListener('mousedown', handleMouseDown);
				container.removeEventListener('mousemove', handleMouseMove);
				container.removeEventListener('mouseup', handleMouseUp);
				container.removeEventListener('mouseleave', handleMouseUp);
				container.removeEventListener('click', handleClick, true);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isDragging, startPosition, scrollPosition, hasMoved]);

	return (
		<DpScrollContainer ref={scrollContainerRef} {...props}>
			{children}
		</DpScrollContainer>
	);
};
